// extracted by mini-css-extract-plugin
export default {"wrapper":"characterizes_wrapper__WXU1g","title":"characterizes_title__8m0C4","pannel":"characterizes_pannel__CLmE8"};